import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.CHECKOUT.STEP_LOAD, ({ cartState }) => {
  //
})

eventBus.$on(eventDefinitions.ORDER.PLACED, ({ order }) => {
  //
})

eventBus.$on(eventDefinitions.PRODUCT.PAGE_VIEW, ({ product }) => {
  //
})

eventBus.$on(eventDefinitions.SITE.PAGE_VIEW, ({ page_route_name, page_url }) => {
  //
})
